import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useImperativeHandle } from 'react';
import { useCurveLine } from './useCurveLine';
export * from './useCurveLine';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    curveLine,
    BMapLib,
    setPath
  } = useCurveLine(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setPath(props.path), [props.path]);
  useImperativeHandle(ref, () => _extends({}, props, {
    curveLine,
    BMapLib
  }));
  return null;
});